// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

export const customerTriageQueryKey = ['customer-triage'] as const;

export function triageCustomerListQueryKey(filter?: unknown) {
  return filter ? [...customerTriageQueryKey, filter] : customerTriageQueryKey;
}
